export default {
  "dataIterator": {
    "rowsPerPageText": "Registros por página:",
    "rowsPerPageAll": "Todos",
    "pageText": "{0}-{1} de {2}",
    "noResultsText": "No se encontraron registros coincidentes",
    "nextPage": "Página siguiente",
    "prevPage": "Página anterior"
  },
  "dataTable": {
    "rowsPerPageText": "Registros por página:"
  },
  "noDataText": "Datos no disponibles"
}


// WEBPACK FOOTER //
// ./src/components/vuetify/locale/es.js